import React, { Fragment, useEffect, useState } from 'react'
import Material from './Material'
import { useDispatch, useSelector } from 'react-redux'

// import {
//   GoogleReCaptchaProvider,
//   withGoogleReCaptcha,
// } from "react-google-recaptcha-v3";

// const YourReCaptchaComponent = withGoogleReCaptcha(Material);

const ReCaptcha = () => {
  return (
    // <GoogleReCaptchaProvider
    //   reCaptchaKey="6Lf1cbUaAAAAACQoU0ftPwd84_CMKKO1ugQquy7y"
    // //   scriptProps={{ async: true, defer: true, appendTo: 'body' }}
    // >
    <Material />
    // </GoogleReCaptchaProvider>
  )
}

export default ReCaptcha
